import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), React.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "1"
}), React.createElement("circle", {
  cx: "13",
  cy: "8",
  r: "1"
}), React.createElement("circle", {
  cx: "13",
  cy: "16",
  r: "1"
}), React.createElement("path", {
  d: "M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), React.createElement("circle", {
  cx: "13",
  cy: "12",
  r: "1"
}), React.createElement("path", {
  d: "M3 3h18v2H3z"
}), React.createElement("circle", {
  cx: "5",
  cy: "8",
  r: "1.5"
}), React.createElement("circle", {
  cx: "5",
  cy: "12",
  r: "1.5"
}), React.createElement("circle", {
  cx: "5",
  cy: "16",
  r: "1.5"
}), React.createElement("path", {
  d: "M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "1"
}), React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "1"
}), React.createElement("path", {
  d: "M3 19h18v2H3z"
})), 'BlurLinearTwoTone');